/* globals Components */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import throttle from 'lodash/throttle';

import css from './FullscreenListBlock.module.scss';

import { scrollIntoView } from 'utils';

import Button from 'components/Button';
//import Components from 'constants/components';

class FullscreenListBlock extends React.Component {
    static propTypes = {
        sections: PropTypes.array,
        duration: PropTypes.number
    }

    static defaultProps = {
        duration: 400
    }

    state = {
        active: 0
    }

    constructor(props){
        super(props);

        this.sliding = false;
        this.scrollTop = 0;

        this.sections = props.sections;
        this.slideDurationSetting = props.duration;
    }

    _handleScroll = throttle(() => {
        if(this.sliding){
            return;
        }
        let active = 0;
        for(let i = 0; i < this.list.childNodes.length; i++){
            let rect = this.list.childNodes[i].getBoundingClientRect();

            // console.log(i, rect.top, rect.bottom);
            if(rect.bottom > this.list.offsetHeight / 2){
                // console.log(rect);
                active = i;
                break;
            }
        }

        this.setState({ active });
    }, 50);

    setActive = (e) => {
        e.preventDefault();
        const { id } = e.currentTarget.dataset;
        this.setActiveId(parseInt(id, 10));
    }

    setActiveId = (id) => {
        if(id >= this.list.childNodes.length || id < 0){
            return;
        }
        this.sliding = true;
        this.setState({ active: id }, () => {
            scrollIntoView(this.list, this.list.childNodes[id], this.slideDurationSetting, () =>{
                this.sliding = false;
            });
        });
    }

    render() {
        const { active } = this.state;

        return (
            <div className={cn(css.block)}>
                {/* Sections */}
                <div
                    className={cn(css.list, "fullscreen-list")}
                    ref={node => this.list = node}
                    onScroll={this._handleScroll}
                >
                    {this.sections.map((section, index) => {
                        // Dynamically fetch component from contentType
                        const Component = Components[section.contentType];
                        if(! Component) {
                            console.error(`Components.${section.contentType} is not defined`);
                            return null;
                        }

                        return (
                            <section key={index}>
                                <div className={section.contentType == "ArticleListBlock" || section.contentType == "InfographicListBlock" ? css.adaptiveHeightContainer : null }>
                                    {/* dynamic component */}
                                    <Component
                                        frontpage={true}
                                        {...section}
                                    />
                                    {/* inject a scroll indicator on the first section */}
                                    { index === 0 && <Button icon={"arrow-down"} className={css["scroll-button"]} onClick={() => { this.setActiveId(1);}}/> }
                                </div>
                            </section>
                        );
                    })}
                </div>
                {/* Indicators */}
                <div className={cn(css.indicators)} ref={node=>this.indicators=node}>
                    {this.sections.map((section, index) => {
                        return <a
                            href="#"
                            onClick={this.setActive}
                            key={index}
                            data-id={index}
                            className={cn(css.indicator, {
                                [css.active]: active.toString() === index.toString()
                            })}>
                        </a>;
                    })}
                </div>
            </div>
        );
    }
}

export default FullscreenListBlock;



// WEBPACK FOOTER //
// ./src/components/FullscreenListBlock/FullscreenListBlock.jsx